import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const servicepartnerColumns: TableColumnsType<ServicePartner> = [
  { title: "Groep Naam", dataIndex: "groupName", key: "groupName" },
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (_: any, record) => (
      <a href={`/service-partners/partners/${record.id}`}>{record.name}</a>
    ),
  },
  {
    title: "Plaats",
    key: "city",
    render: (_: any, record) => record?.address?.city,
  },
  { title: "E-mail", dataIndex: "email", key: "email" },
  { title: "Telefoonnummer", dataIndex: "telephone", key: "telephone" },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/service-partners/partners/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
